var OrganizationSearchItem;

export default OrganizationSearchItem = Vue.extend({
  props: {
    organization: {
      type: Object
    },
    selectedSearchOrganization: {
      type: Object
    }
  },
  data: function() {
    return {
      showTooltip: false
    };
  },
  computed: {
    ancestors: function() {
      var ancestorsNames, str;
      ancestorsNames = this.organization.ancestor_names;
      str = '';
      if (ancestorsNames.length > 1) {
        _.map(ancestorsNames, function(ancestor) {
          if (ancestor === ancestorsNames[ancestorsNames.length - 1]) {
            return str += ancestor;
          } else {
            return str += ancestor + ' > ';
          }
        });
        return str;
      } else if (ancestorsNames.length === 1) {
        return `${ancestorsNames[0]}`;
      }
    }
  },
  template: `<div class="organization-search-item" :class="{selected: selectedSearchOrganization.id == organization.id}" @click="selectedSearchOrganizationFunc">
  <div class="organization-name text-ellipsis">{{organization.name}}</div>
  <div class="slp-tooltip organization-ancestor-tooltip top without-delay"
       v-if="showTooltip"
       :data-title="ancestors">
  </div>
  <div class="organization-ancestor" v-if="organization.ancestor_names.length">
      <div class="ancestors-title">隶属于：</div>
      <div class="ancestors"  ref="ancestorRef">{{ancestors}}</div>
  </div>
</div>`,
  mounted: function() {
    var clientWidth, ref, ref1, scrollWidth;
    clientWidth = (ref = this.$refs.ancestorRef) != null ? ref.clientWidth : void 0;
    scrollWidth = (ref1 = this.$refs.ancestorRef) != null ? ref1.scrollWidth : void 0;
    if (scrollWidth > clientWidth) {
      return this.showTooltip = true;
    } else {
      return this.showTooltip = false;
    }
  },
  methods: {
    selectedSearchOrganizationFunc: function() {
      return this.$emit('selectedSearchOrganizationFunc', this.organization);
    }
  }
});
